import { render, staticRenderFns } from "./BottomNavBadge.vue?vue&type=template&id=02e2bb46&scoped=true&"
import script from "./BottomNavBadge.vue?vue&type=script&lang=js&"
export * from "./BottomNavBadge.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavBadge.vue?vue&type=style&index=0&id=02e2bb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e2bb46",
  null
  
)

export default component.exports